<template>
  <div class="contact-form-success">
    <div class="success-contact-form-car__content">
      <div>
        <p class="success-contact-form-car__text">
          Fyrirspurn hefur verið send.
          Haft verður samband við þig við fyrsta tækifæri.
        </p>
        <ButtonLink :href="brandUrl" class="success-contact-form-car__btn-link">
          Skoða fleiri {{dataCar.brand}}
        </ButtonLink>
      </div>
      <div class="success-contact-form-car__image-car">
        <img :src="carImage" alt />
      </div>
    </div>
    <!-- <div class="success-contact-form-car__contacts">
      <div class="success-contact-form-car__logo">
        <img src="https://www.bl.is/images/logo.svg" alt />
      </div>

      <span class="title-h3 success-contact-form-car__title">BL ehf.</span>

      <div class="success-contact-form-car__buttons">
        <ButtonPhone class="mb-3">
          Sýna símanumer
        </ButtonPhone>

        <ButtonEmail class="mb-3">
          Vefsíða
        </ButtonEmail>
      </div>

      <span class="title-h3">Við erum hér</span>
      <div class="salon-cars__contacts-flex">
        <MarkerIcon/>
        <div class="success-contact-form-car__contacts-block">
          <span class="success-contact-form-car__contacts-text">{{companyAdress}}</span>
        </div>
      </div>
      <div class="flex">
        <span class="success-contact-form-car__little-text">
          Alla virka daga <br>
          10:00 - 18:00
        </span>

        <span class="success-contact-form-car__little-text">
          Lokað um helgar
        </span>
      </div>
      <a
        v-if="googleMapAddress"
        :href="googleMapAddress"
        target="_blank"
        class="contacts-map-link"
      >+ Sjá staðsetningu á korti</a>
    </div> -->
  </div>
</template>

<script>
import ButtonLink from "@/components/Dealers/share/ButtonLink"
// import ButtonPhone from "@/components/Dealers/share/ButtonPhone"
// import ButtonEmail from "@/components/Dealers/share/ButtonEmail"
//
// import MarkerIcon from "@/components/svg/MapMarkerIcon"
export default {
  components: {
    ButtonLink,
    // ButtonPhone,
    // ButtonEmail,
    // MarkerIcon
  },
  props: {
    dataCar: {
      type: Object,
      default: () => ({})
    },
    brandUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    carImage() {
      return this.dataCar && this.dataCar.thumbnail || '/img/main-thumb.png'
    },
    companyAdress() {
      return this.dataCar && this.dataCar.company && this.dataCar.company.address
    },
    googleMapAddress() {
      const address = this.dataCar && this.dataCar.company && this.dataCar.company.address

      return address 
        ? `https://maps.google.com/?q=${address}`
        : null
    }
  }
};
</script>

<style>
</style>